import * as React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Input, Checkbox } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import { Button } from "@progress/kendo-react-buttons";
import SubmitButton from "components/common/SubmitButton";

const validateForm = (values) => {
  const errors = {};

  if (!values.code?.trim()) {
    errors.code = "Department code is required";
  }

  if (!values.name?.trim()) {
    errors.name = "Department name is required";
  }

  return errors;
};

const EditDepartment = (props) => {
  const ADD_NEW = props.type === "addNew";
  const [submitAttempted, setSubmitAttempted] = React.useState(false);

  return (
    <Dialog
      title={ADD_NEW ? "Add Department" : `Edit ${props?.item?.name}`}
      onClose={props.cancelEdit}
      width={600}
    >
      <Form
        onSubmit={props.onSubmit}
        initialValues={{ active: true, ...props.item }}
        validator={validateForm}
        render={(formRenderProps) => (
          <>
            <div className="p-3 ps-4">
              <FormElement
                style={{
                  maxWidth: 1200,
                }}
              >
                <fieldset className={"k-form-fieldset"}>
                  <div className="mb-2">
                    <Label className="label mt-1 mb-2 w-100">Code&nbsp;</Label>
                    <Field
                      name="code"
                      component={Input}
                      maxLength={5}
                      placeholder="Enter Code"
                    />
                    {submitAttempted && formRenderProps.errors?.code && (
                      <div className="fs-sm my-1 text-danger">
                        <i>{formRenderProps.errors.code}</i>
                      </div>
                    )}
                  </div>
                  <div className="mb-2">
                    <Label className="label mt-1 mb-2 w-100">Name&nbsp;</Label>
                    <Field
                      name="name"
                      component={Input}
                      maxLength={20}
                      placeholder="Enter Name"
                    />
                    {submitAttempted && formRenderProps.errors?.name && (
                      <div className="fs-sm my-1 text-danger">
                        <i>{formRenderProps.errors.name}</i>
                      </div>
                    )}
                  </div>
                  <Field
                    name="active"
                    className="mt-2"
                    component={Checkbox}
                    label="Active"
                  />
                </fieldset>
              </FormElement>
            </div>
            <div className="dialog-footer">
              <Button
                className="common-btn bgBtnSecondary me-3"
                onClick={props.cancelEdit}
              >
                Cancel
              </Button>
              <SubmitButton
                className="me-3"
                onClick={() => {
                  setSubmitAttempted(true);
                  formRenderProps.onSubmit();
                }}
                disabled={!formRenderProps.allowSubmit}
                isLoading={props.isSubmitting}
              >
                {ADD_NEW ? "Save" : "Update"}
              </SubmitButton>
            </div>
          </>
        )}
      />
    </Dialog>
  );
};

export default EditDepartment;
